import { render, staticRenderFns } from "./MastitisGoals.vue?vue&type=template&id=c4a6997e&"
import script from "./MastitisGoals.vue?vue&type=script&lang=js&"
export * from "./MastitisGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports